<template>
	<div class="get-help display-flex flex-row flex-align-center" :class="{ extended }" @click.stop="getHelp">
		<span><SIcon name="idea-get-help" class="mr-1" :width="16" :height="16" v-if="extended" /> Get help building this</span>
	</div>
</template>
<script>
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
export default {
	name: 'GetHelpBuildingIdea',
	props: { idea: { type: Object }, extended: { type: Boolean } },
	methods: {
		getHelp() {
			AppDialogManagerService.openHelpBuildingIdeaDialog({ ideaId: this.idea.id });
		},
	},
};
</script>

<style scoped lang="scss">
.get-help {
	cursor: pointer;
	span {
		letter-spacing: 0px;
		color: #98a2b7;
		font-size: 12px;
	}
	&.extended span {
		font-size: 14px;
		color: #6964eb;
	}
}
</style>
